import aih from './aih'
import atendimentoEnfermagem from './atendimento-enfermagem'
import atendimentoMedico from './atendimento-medico'
import plantao from './plantao'
import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/pronto-atendimento`

    const headers = { responseType: "arraybuffer" }

    return {
        aih: aih(baseUrl),
        atendimentoMedico: atendimentoMedico(baseUrl),
        atendimentoEnfermagem: atendimentoEnfermagem(baseUrl),
        plantao: plantao(baseUrl),
        relatorioQuantitativoProducao(queryParms) {

            return repository.get(`${baseUrl}/relatorio-quantitativo-producao?${urlUtil.serialize(queryParms)}`, headers)
        },
        cat(atendimentoId) {

            return repository.get(`${baseUrl}/cat/${atendimentoId}`, headers)
        },
        raat(atendimentoId) {

            return repository.get(`${baseUrl}/raat/${atendimentoId}`, headers)
        },
        termoCiencia(atendimentoId) {

            return repository.get(`${baseUrl}/termo-ciencia/${atendimentoId}`, headers)
        },
        faa: {
            eletronica(atendimentoId, queryParms = {}) {

                return repository.get(`${baseUrl}/faa-eletronica/${atendimentoId}?${urlUtil.serialize(queryParms)}`, headers)
            },
            simplificada(atendimentoId) {

                return repository.get(`${baseUrl}/faa-simplificada/${atendimentoId}`, headers)
            },
            completa(atendimentoId) {

                return repository.get(`${baseUrl}/faa-completa/${atendimentoId}`, headers)
            },
        },
        relatorioAtendimento(params) {
            return repository.post(`${baseUrl}/relatorio-atendimento`, params, headers)
        },
        relatorioClassificacaoRisco(queryParms) {
            return repository.get(`${baseUrl}/relatorio-classificacao-risco?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioProducaoMedico(queryParms) {
            return repository.get(`${baseUrl}/relatorio-producao-medico?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioDocumentoNaoAssinado(queryParms) {
            return repository.get(`${baseUrl}/relatorio-documento-nao-assinado?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioExameImagem(queryParms) {
            return repository.get(`${baseUrl}/relatorio-exame-imagem?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioPrescricaoInterna(queryParms) {
            return repository.get(`${baseUrl}/relatorio-prescricao-interna?${urlUtil.serialize(queryParms)}`, headers)
        },
    }
}
